import { render } from "./QuestionCardMultiSelect.vue?vue&type=template&id=5c21f7c2"
import script from "./QuestionCardMultiSelect.vue?vue&type=script&lang=js"
export * from "./QuestionCardMultiSelect.vue?vue&type=script&lang=js"

import "./QuestionCardMultiSelect.vue?vue&type=style&index=0&id=5c21f7c2&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_webpack@5.108.1_postcss@8.5.16_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__